var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpdates(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4609_38181)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7996 10.3984H23.1996C26.3996 10.3984 26.3996 9.39844 26.3996 8.39844C26.3996 6.39844 24.7996 6.39844 23.1996 6.39844H16.7996C15.1996 6.39844 13.5996 6.39844 13.5996 8.39844C13.5996 10.3984 15.1996 10.3984 16.7996 10.3984Z",
    fill: "#E0F3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6963 27.1992L18.0963 29.5992L24.4963 23.1992",
    stroke: "#1552E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7996 10.4H23.1996C26.3996 10.4 26.3996 8.8 26.3996 7.2C26.3996 4 24.7996 4 23.1996 4H16.7996C15.1996 4 13.5996 4 13.5996 7.2C13.5996 10.4 15.1996 10.4 16.7996 10.4Z",
    stroke: "#081E54",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3996 7.23438C31.7276 7.52237 34.3996 9.49037 34.3996 16.8024V26.4024C34.3996 32.8024 32.7996 36.0024 24.7996 36.0024H15.1996C7.19961 36.0024 5.59961 32.8024 5.59961 26.4024V16.8024C5.59961 9.50637 8.27161 7.52237 13.5996 7.23438",
    stroke: "#081E54",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.4,
    y1: 14.8031,
    x2: 27.6,
    y2: 14.8031,
    stroke: "#A020FF",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.4,
    y1: 17.2016,
    x2: 27.6,
    y2: 17.2016,
    stroke: "#A020FF",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.4,
    y1: 19.6039,
    x2: 27.6,
    y2: 19.6039,
    stroke: "#A020FF",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4609_38181"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdates);
export default __webpack_public_path__ + "static/media/Updates.2100b34dffb9dd1c52f5300c36a14442.svg";
export { ForwardRef as ReactComponent };